export default function Footer() {
	return <footer className="footer"></footer>;
}
